import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {},
  marginBottom: {
    marginBottom: 20
  },
  divider: {
    marginBottom: 20,
    marginTop: 20
  },

  gridOverflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '6px !important'
  }
}));

const DealerSummary = ({ dealerInfo = {
  dealerCode: 'N/A',
  dealerName: 'N/A',
  address1: 'N/A',
  address2: 'N/A',
  city: 'N/A',
  state: 'N/A',
  zipCode: 'N/A',
  zipCode2: 'N/A'
} }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (

    <Grid container >
      <Grid item xs={4} className={classes.gridOverflow}>
        <Typography noWrap variant="h5" color="textPrimary">
          {dealerInfo?.dealerCode}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t('glassClaim.dealerCode')}
        </Typography>
      </Grid>
      <Grid item xs={4} className={classes.gridOverflow}>
        <Typography noWrap variant="h5" color="textPrimary">
          {dealerInfo?.dealerName}
        </Typography>
        <Typography noWrap variant="body2" color="textSecondary">
          {t('glassClaim.dealerName')}
        </Typography>
      </Grid>
      <Grid item xs={4} className={classes.gridOverflow} >

        <Typography
          noWrap align="right"
          variant="h5"
          color="textPrimary"
        >
          {dealerInfo?.dealerAddress ?? ''}
        </Typography>
        <Typography
          noWrap align="right"
          variant="h5"
          color="textPrimary"
        >
          {dealerInfo?.dealerCity ?? ''},&nbsp;{dealerInfo?.dealerState ?? ''}&nbsp;
          {dealerInfo?.dealerZip ?? ''}
        </Typography>

        <Typography variant="body2" color="textSecondary" align="right">
          {t('glassClaim.shippingAddress')}
        </Typography>
      </Grid>
    </Grid>

  );
};

DealerSummary.propTypes = {

  dealerInfo: PropTypes.object

};

export default DealerSummary;
